import { render, staticRenderFns } from "./reg_tips.vue?vue&type=template&id=77a2ef5c&scoped=true"
import script from "./reg_tips.vue?vue&type=script&lang=js"
export * from "./reg_tips.vue?vue&type=script&lang=js"
import style0 from "./reg_tips.vue?vue&type=style&index=0&id=77a2ef5c&prod&scoped=true&lang=css"
import style1 from "./reg_tips.vue?vue&type=style&index=1&id=77a2ef5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2ef5c",
  null
  
)

export default component.exports